<template>
  <div>
    <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
    <div v-show="!load">
      <div class="container" style="max-width: 600px">
        <div v-if="!cartoes.length">
          <div class="text-center mt-5">
            <div class="mb-4">
              <icon name="card" class="text-primary" size="48"></icon>
            </div>
            <p>Você ainda não tem nenhum cartão de crédito cadastrado</p>
          </div>
        </div>
        <div v-else>
          <h6 class="text-center mt-4 mb-3">Selecione um cartão</h6>
          <div class="mb-3" v-for="(e, index) in cartoes" :key="index">
            <a href="javascript:" class="card text-dark" @click="selecionarCartao(e.id_cartao);">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div class="mr-3">
                    <img v-if="e.bandeira === '1'" src="https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-corporativo/static/brands/visa.png" alt="" style="width: 32px">
                    <img v-else-if="e.bandeira === '2'" src="https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-corporativo/static/brands/mastercard.png" alt="" style="width: 32px">
                    <img v-else-if="e.bandeira === '3'" src="https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-corporativo/static/brands/amex.png" alt="" style="width: 32px">
                    <img v-else-if="e.bandeira === '6'" src="https://lecard-cdn.nyc3.digitaloceanspaces.com/lecard-corporativo/static/brands/elo-logo.png" alt="" style="width: 32px">
                    <icon v-else name="card" size="32"></icon>
                  </div>
                  <div class="small">
                    Cartão de Crédito
                    <div class="font-weight-bold">**** **** **** {{ e.ultimos_digitos }}</div>
                  </div>
                  <div class="ml-auto text-right">
                    <button class="btn text-danger" @click.stop="deletarCartao(e.id_cartao)" title="Remover">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div>
          <hr>
          <button class="btn btn-outline-primary btn-block" @click="cadastrarCartao">Adicionar novo cartão</button>
        </div>
      </div>
    </div>


    <modal ref="modalCartao" @voltar="fecharModalCartao" :title="'Dados do Cartão'" :overflow="true">
      <form @submit.prevent="enviarCartao()">
        <div id="containerPagamento" class="container container-endereco">
          <div class="pt-4 mb-3">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group mb-2">
                  <label for="numero" class="mb-0">Número do cartão *</label>
                  <div class="position-relative">
                    <the-mask id="numero" type="tel" :mask="['#### #### #### #### ###']" class="form-control" @blur.native="validarBandeira" placeholder="#### #### #### ####" v-model="cartao.numero" required/>
                    <div style="position: absolute; right: 12px; top: 6px">
                      <img v-if="logo_bandeira" :src="logo_bandeira" alt="Cartao" style="width: 32px">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-2">
                  <label for="mes_ano" class="mb-0">Validade *</label>
                  <the-mask id="mes_ano" type="tel" :mask="['##/##']" class="form-control" v-model="cartao.mes_ano"
                            placeholder="MM/AA" required/>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-2">
                  <label for="cvv" class="mb-0">CVV *</label>
                  <the-mask id="cvv" type="tel" :mask="['####']" class="form-control" v-model="cartao.cvv"
                            placeholder="###" required/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label for="nome" class="mb-0">Nome do titular *</label>
                  <input id="nome" type="text" class="form-control" @blur="validarDados" placeholder="Ex: ANA MARIA"
                         maxlength="256" v-model="cartao.nome" required>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label for="documento" class="mb-0">CPF / CNPJ do titular</label>
                  <the-mask id="documento" type="tel" :mask="['###.###.###-##','##.###.###/####-##']" class="form-control"
                            v-model="cartao.documento" placeholder="###.###.###-##" required/>
                </div>
              </div>
            </div>
            <div class="mt-3 text-center">
              <h6 class="mb-2">Endereço de cobrança</h6>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group mb-2">
                  <label for="endereco" class="mb-0">Endereço *</label>
                  <input id="endereco" type="text" class="form-control" placeholder="Ex: Rua Joaquim de Oliveira"
                         maxlength="256" v-model="cartao.logradouro" :disabled="loadEndereco" required>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-2">
                  <label for="numero_endereco" class="mb-0">Número *</label>
                  <input id="numero_endereco" type="text" class="form-control" placeholder="Ex 1170" maxlength="11"
                         v-model="cartao.numero_endereco" :disabled="loadEndereco" required>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-2">
                  <label for="bairro" class="mb-0">Bairro *</label>
                  <input id="bairro" type="text" class="form-control" placeholder="Ex Centro" maxlength="100"
                         v-model="cartao.bairro" :disabled="loadEndereco" required>
                </div>
              </div>
              <div class="col-6 mb-2">
                <label for="cep" class="mb-0">CEP</label>
                <the-mask id="cep" :mask="['#####-###']" class="form-control mb-2 mb-md-0" placeholder="Ex: 14403-110" v-model="cartao.cep" :disabled="loadEndereco" required/>
              </div>
              <div class="col-6">
                <div class="form-group mb-3">
                  <label for="complemento" class="mb-0">Complemento</label>
                  <input id="complemento" class="form-control" placeholder="Complemento / Bloco / Apto" v-model="cartao.complemento" maxlength="100" :disabled="loadEndereco"/>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-2">
                  <label for="cidade" class="mb-0">Cidade</label>
                  <input id="cidade" type="text" class="form-control" placeholder="Ex Belo Horizonte" maxlength="100"
                         v-model="cartao.nome_cidade" :disabled="loadEndereco" required>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-2">
                  <label for="estado" class="mb-0">Estado</label>
                  <select id="estado" class="form-control" v-model="cartao.estado" :disabled="loadEndereco" required>
                    <option value="">Selecione</option>
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                    <option value="EX">Estrangeiro</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="border-top btn-avancar fixed-container">
          <div class="p-2">
            <button type="submit" class="btn btn-primary btn-block btn-bottom" :disabled="loadCartao">
              <span v-if="loadCartao"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
              <span v-else>Salvar</span>
            </button>
          </div>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask';
import Loading from "../components/Loading";
import Icon from "../components/Icon";
import Modal from "../components/Modal";

export default {
  name: 'CartoesPagarme',
  components: {Loading, TheMask, Icon, Modal},
  data() {
    return {
      token: localStorage.getItem('token'),
      load: true,
      modal: false,
      cartoes: [],
      loadCartao: false,
      loadEndereco: false,
      dataUser: {},
      logo_bandeira: null,
      cartao: {
        numero: '',
        nome: '',
        mes_ano: '',
        cvv: '',
        documento: '',
        bandeira: '99',
        logradouro: '',
        numero_endereco: '',
        complemento: '',
        nome_cidade: '',
        bairro: '',
        cep: '',
        estado: ''
      }
    }
  },

  methods: {
    selecionarCartao(id_cartao) {
      this.$emit('selecionarCartao', id_cartao);
    },

    limparCartao() {
      this.cartao.numero = "";
      this.cartao.nome = "";
      this.cartao.mes_ano = ""
      this.cartao.cvv = "";
      this.cartao.documento = "";
      this.cartao.bandeira = "99";
      this.cartao.logradouro = "";
      this.cartao.numero_endereco = "";
      this.cartao.complemento = "";
      this.cartao.nome_cidade = "";
      this.cartao.bairro = "";
      this.cartao.cep = "";
      this.cartao.estado = "";
    },

    fecharModalCartao() {
      this.modal = false;
      this.$emit('closeModal');

      if (!this.cartoes.length) {
        this.$router.go(-1)
      }
    },

    enviarCartao() {
      if (this.loadCartao) {
        return;
      }

      if (this.validarCampos()) {
        this.loadCartao = true;
        this.cartao.plataforma = 5;
        this.$http.post(this.$store.state.base_url + this.token + '/cartao/criar', this.cartao)
          .then(response => {
            this.loadCartao = false;

            if (response.data.success) {
              this.$emit('closeModal');
              this.limparCartao();

              this.buscarCartoes(() => {
                if (response.data.id_cartao) {
                  this.selecionarCartao(response.data.id_cartao);
                }
              });

            } else {
              this.$swal('Erro temporário');
            }

          }, res => {
            this.loadCartao = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      }
    },

    validarCampos() {
      if (this.cartao.numero.length < 15) {
        this.$swal('Por favor informe um numero de cartão válido!').then(() => {
          this.$helpers.focusrElement('numero');
        });

        return false;
      }

      if (this.cartao.mes_ano.length < 4) {
        this.$swal('Por favor informe uma data de validade válida!').then(() => {
          this.$helpers.focusrElement('mes_ano');
        });

        return false;

      } else {
        let mes = this.cartao.mes_ano.substring(0,2);
        let ano = this.cartao.mes_ano.substring(2,4);

        if (parseInt(mes) < 1 || parseInt(mes) > 12 || parseInt(ano) < 23) {
          this.$swal('Por favor informe uma data válida na validade!').then(() => {
            this.$helpers.focusrElement('mes_ano');
          });

          return false;
        }
      }

      if (this.cartao.cvv.length < 3) {
        this.$swal('Por favor informe um CVV válido!').then(() => {
          this.$helpers.focusrElement('cvv');
        });

        return false;
      }

      if (this.cartao.documento.length <= 11 && !this.$helpers.validarCpf(this.cartao.documento)) {
        this.$swal('Por favor informe um CPF válido!').then(() => {
          this.$helpers.focusrElement('documento');
        });

        return false;
      }

      if (this.cartao.documento.length > 11 && this.cartao.documento.length !== 14) {
        this.$swal("Por favor informe um CNPJ válido").then(() => {
          this.$helpers.focusrElement("documento")
        });

        return;
      }

      if (!this.cartao.cep.length) {
        this.$swal('Por favor informe um cep válido!').then(() => {
          this.$helpers.focusrElement('cep');
        });

        return false;
      }

      if (!this.cartao.logradouro.length) {
        this.$swal('Por favor informe um endereço válido!').then(() => {
          this.$helpers.focusrElement('logradouro');
        });

        return false;
      }

      if (!this.cartao.numero_endereco.length) {
        this.$swal('Por favor informe um número de endereço válido!').then(() => {
          this.$helpers.focusrElement('numero_endereco');
        });

        return false;
      }

      if (!this.cartao.nome_cidade.length) {
        this.$swal('Por favor informe uma cidade válida!').then(() => {
          this.$helpers.focusrElement('nome_cidade');
        });

        return false;
      }

      if (!this.cartao.estado.length) {
        this.$swal('Por favor informe um estaod (UF) válido!').then(() => {
          this.$helpers.focusrElement('estado');
        });

        return false;
      }

      return true;
    },

    validarBandeira() {
      if (this.cartao.numero.length) {
        const numeroBandeira = this.cartao.numero.length ? this.cartao.numero[0] : '';

        switch (numeroBandeira) {
          case "2": // Mastercard
          case "5":
            this.cartao.bandeira = "2";
            this.logo_bandeira = "https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-corporativo/static/brands/mastercard.png";
            break;
          case "4": // Visa
            this.cartao.bandeira = "1";
            this.logo_bandeira = "https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-corporativo/static/brands/visa.png";
            break;
          case "3": // American Express
            this.cartao.bandeira = "3";
            this.logo_bandeira = "https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-corporativo/static/brands/amex.png";
            break;
          default:
            this.logo_bandeira = null;
            this.cartao.bandeira = "99";
            break;
        }

      } else {
        this.cartao.bandeira = "99";
      }
    },

    validarDados() {
      this.cartao.nome = this.cartao.nome.replace(/[^a-zA-Z ]/g, '').toUpperCase();
    },

    buscarCartoes(callback) {
      this.load = true;
      this.$http.get(this.$store.state.base_url + this.token + '/cartao/buscar?plataforma=5')
        .then(response => {
          this.load = false;

          if (response.data) {
            this.cartoes = response.data || [];

            if (!this.cartoes.length) {
              this.cadastrarCartao();

            } else if (callback) {
              callback();
            }
          }

        }, res => {
          this.load = false;
          let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
          this.$swal(msg);
        });
    },

    deletarCartao(id_cartao) {
      this.$swal({
        text: 'Deseja realmente deletar o cartão?',
        buttons: ["Não", "Sim"],
        dangerMode: true
      }).then((res) => {
        if (res) {
          this.load = true;
          this.$http.post(this.$store.state.base_url + this.token + '/cartao/deletar', {id_cartao: id_cartao, plataforma: 5}).then(response => {
            this.$swal("Cartão deletado com sucesso!");
            this.buscarCartoes();
            this.load = false;

          }, res => {
            let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
            this.$swal(msg);
            this.load = false;
          });
        }
      });
    },

    cadastrarCartao() {
      this.limparCartao();
      this.buscarEnderecoPrincipal();
      this.$emit('openModal');
      this.modal = true;

      this.$nextTick(() => {
        this.$helpers.focusrElement('numero');
      })
    },

    clearEndereco() {
      this.cartao.logradouro = '';
      this.cartao.complemento = '';
      this.cartao.bairro = '';
      this.cartao.numero_endereco = '';
      this.cartao.nome_cidade = '';
      this.cartao.estado = '';
    },

    buscarEnderecoPrincipal() {
      this.loadEndereco = true;
      const url = this.$helpers.base_url(this, this.empresa);

      this.$http.get(url + this.token + '/cliente')
        .then(response => {
          this.loadEndereco = false;

          if (response.data) {
            this.dados = response.data;
            this.dataUser = this.dados;
            this.cartao.documento = this.$store.state.dataUser.cpf || '';

            if (this.dataUser.enderecos.length > 0) {
              let busca = this.dataUser.enderecos.find(e => e.selecionado === "1")
              let enderecoBase = busca || this.dataUser.enderecos[0];
              this.cartao.logradouro = enderecoBase.logradouro;
              this.cartao.numero_endereco = enderecoBase.numero;
              this.cartao.complemento = enderecoBase.complemento;
              this.cartao.nome_cidade = enderecoBase.nome_cidade;
              this.cartao.bairro = enderecoBase.bairro;
              this.cartao.cep = enderecoBase.cep_endereco || '';
              this.cartao.estado = enderecoBase.sigla_estado;
            }
          }

        }, res => {
          this.loadEndereco = false;
        });
    }
  },

  created() {
    document.body.classList.remove("modal-open");
  },

  mounted() {
    this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';

    if (this.token) {
      window.scrollTo(0, 0);
      this.buscarCartoes();
    }
  },

  computed: {
    empresa() {
      return this.$store.state.empresa
    }
  }
}
</script>

<style scoped>
.btn-avancar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
  background-color: #fff;
}

.container-endereco {
  padding-bottom: 80px;
}

@media (min-width: 768px) {
  .btn-avancar {
    position: static;
    padding-right: 15px;
    padding-left: 15px;
  }

  .container-endereco {
    overflow: auto;
    height: calc(80vh - 140px);
    padding-bottom: 0;
  }
}
</style>
